import { useState } from 'react';
import { Button } from './button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './dropdown-menu';
import { Calendar, ChevronDown, Download } from 'lucide-react';
import { getAllCalendarLinks, createClassEvent } from '../../lib/calendarUtils';

/**
 * Add to Calendar Button Component
 * Provides options to add class to Google Calendar, Outlook, or download ICS
 */
const AddToCalendarButton = ({ 
  classData, 
  schedule, 
  variant = 'outline',
  size = 'sm',
  className = ''
}) => {
  const [open, setOpen] = useState(false);

  if (!classData || !schedule) return null;

  const event = createClassEvent(classData, schedule);
  const links = getAllCalendarLinks(event);

  const handleGoogleCalendar = () => {
    window.open(links.google, '_blank');
    setOpen(false);
  };

  const handleOutlook = () => {
    window.open(links.outlook, '_blank');
    setOpen(false);
  };

  const handleDownloadICS = () => {
    links.downloadICS();
    setOpen(false);
  };

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button 
          variant={variant} 
          size={size}
          className={`gap-2 ${className}`}
          data-testid="add-to-calendar-btn"
        >
          <Calendar className="w-4 h-4" />
          Add to Calendar
          <ChevronDown className="w-3 h-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={handleGoogleCalendar} className="cursor-pointer">
          <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none">
            <path d="M19.5 3.5H4.5C3.4 3.5 2.5 4.4 2.5 5.5V19.5C2.5 20.6 3.4 21.5 4.5 21.5H19.5C20.6 21.5 21.5 20.6 21.5 19.5V5.5C21.5 4.4 20.6 3.5 19.5 3.5Z" fill="#4285F4"/>
            <path d="M12 11L2.5 5.5V19.5C2.5 20.6 3.4 21.5 4.5 21.5H19.5C20.6 21.5 21.5 20.6 21.5 19.5V5.5L12 11Z" fill="#34A853"/>
            <path d="M21.5 5.5L12 11L2.5 5.5C2.5 4.4 3.4 3.5 4.5 3.5H19.5C20.6 3.5 21.5 4.4 21.5 5.5Z" fill="#EA4335"/>
            <path d="M12 11L21.5 5.5V8L12 13.5L2.5 8V5.5L12 11Z" fill="#FBBC05"/>
          </svg>
          Google Calendar
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleOutlook} className="cursor-pointer">
          <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none">
            <path d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3Z" fill="#0078D4"/>
            <path d="M12 13L1 6V5L12 12L23 5V6L12 13Z" fill="white"/>
          </svg>
          Outlook
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleDownloadICS} className="cursor-pointer">
          <Download className="w-4 h-4 mr-2" />
          Download .ics
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AddToCalendarButton;
